<script>
export let active_tab;


let tabs = [
	{
		text: 'Registrations',
		id: 'registrations',
	},
	{
		text: 'Parents',
		id: 'parents',
	},
]



function changeTab(id) {
	active_tab = id;
}

</script>



<style>


</style>



<div class="tabs is-toggle">

	<ul>

		{#each tabs as tab}

			<li class:is-active={active_tab === tab.id}>
				<a on:click={() => changeTab(tab.id)}>{tab.text}</a>
			</li>

		{/each}

	</ul>

</div>

